import { Router } from '@angular/router';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-back-navigation-btn',
  templateUrl: './back-navigation-btn.component.html',
  styleUrls: ['./back-navigation-btn.component.scss']
})
export class BackNavigationBtnComponent implements OnInit {
  @Input() routeUrl: string;
  @Input() emitEvent: boolean;
  @Output() handleCallBack = new EventEmitter();
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  onClick(): void {
    if (this.routeUrl) {
      this.router.navigateByUrl(`/${this.routeUrl}`);
    } else if (this.emitEvent) {
      this.handleCallBack.emit();
    } else {
      history.back();
    }
  }
}
